<template>
    <div class="collaboration__form">
        <div class="collaboration__form-title">Оставьте свои контакты для связи</div>
        <form @submit.prevent="debounce(validate)" class="form">
            <div class="form__inputs">
                <div class="custom-input">
                    <input v-bind:class="{'custom-input__input--error':errors.some(er => er.code === 4)}"
                           @input="this.reset" v-model="name" autocomplete="off"
                           class="custom-input__input" type="text" placeholder="Введите ФИО">
                    <span v-if="errors.some(er => er.code === 4)" class="custom-input__error"></span>
                    <label class="custom-input__label">ФИО</label>
                </div>
                <div class="custom-input">
                    <input v-bind:class="{'custom-input__input--error':errors.some(er => er.code === 1)}"
                           @input="this.reset" v-model="phone" @paste.prevent="removeFirstDigit" autocomplete="off"
                           class="custom-input__input" type="text" inputmode="numeric" placeholder="Введите Телефон" data-mask-phone>
                    <span v-if="errors.some(er => er.code === 1)" class="custom-input__error"></span>
                    <label class="custom-input__label">Телефон</label>
                </div>
                <div class="custom-input">
                    <input v-bind:class="{'custom-input__input--error':errors.some(er => er.code === 5)}"
                           @input="this.reset" v-model="email" autocomplete="off"
                           class="custom-input__input" type="text" placeholder="Введите E-mail">
                    <span v-if="errors.some(er => er.code === 5)" class="custom-input__error"></span>
                    <label class="custom-input__label">E-mail</label>
                </div>
                <div class="custom-input">
                    <input v-bind:class="{'custom-input__input--error':errors.some(er => er.code === 10)}"
                           @input="this.reset" v-model="company" autocomplete="off"
                           class="custom-input__input" type="text" placeholder="Введите Название компании">
                    <span v-if="errors.some(er => er.code === 10)" class="custom-input__error"></span>
                    <label class="custom-input__label">Название компании</label>
                </div>
                <div class="custom-textarea">
                    <textarea v-bind:class="{'custom-input__input--error':errors.some(er => er.code === 11)}"
                              @input="this.reset" v-model="comment" autocomplete="off"
                              class="custom-textarea__textarea" type="text" placeholder="Оставьте свой комментарий"></textarea>
                    <span v-if="errors.some(er => er.code === 11)" class="custom-input__error"></span>
                    <label class="custom-textarea__label">Комментарий</label>
                </div>
                <div style="display: none">
                    <vue-recaptcha
                        ref="recaptcha"
                        size="invisible"
                        :sitekey="this.site_key"
                        @verify="sendData"
                        @expired="onCaptchaExpired"
                    />
                </div>
            </div>
            <div class="form__submit">
                <input class="btn btn--mini" type="submit" value="Отправить"/>
            </div>
        </form>
    </div>
</template>

<script>
import recaptcha from "@/components/mixins/recaptcha";
import errors from "@/components/mixins/errors";
import tools from "@/components/mixins/tools";
import { reachGoal as ymReachGoal } from "@/modules/metrika";

export default {
    name: "CollaborationForm",
    mixins: [recaptcha, errors, tools],
    data() {
        return {
            name: '',
            email: '',
            phone: '',
            company: '',
            comment: '',
        }
    },
    methods: {
        sendData(recaptchaToken) {
            this.reset();
            let formData = new FormData();
            formData.append('name', this.name);
            formData.append('email', this.email);
            formData.append('phone', this.phone);
            formData.append('company', this.company);
            formData.append('comment', this.comment);
            formData.append('token', recaptchaToken);
            fetch("/api/cooperation/", {method: 'POST', body: formData})
                .then(response => response.json())
                .then(async resp => {
                    if (resp.success !== true) {
                        let errs = JSON.parse(resp.message);
                        this.parse(errs);
                    } else {
                        ymReachGoal('collaboration');
                        window.toast.success('Сотрудничество', 'Ваша заявка успешно отправлена.');
                        this.name = '';
                        this.email = '';
                        this.phone = '';
                        this.company = '';
                        this.comment = '';
                    }
                });
        }
    }
}
</script>

<style scoped>

</style>
